"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onClickListener = exports.onClickEvents = void 0;
const ga_event_1 = require("../helpers/ga-event");
const general_1 = require("../helpers/general");
let page = "(not set)";
function onClickEvents(eventPage) {
    page = eventPage;
    document.removeEventListener("click", onClickListener);
    document.addEventListener("click", onClickListener);
}
exports.onClickEvents = onClickEvents;
function onClickListener(event) {
    var _a, _b;
    const element = event.target;
    if (!element.classList.contains("ga-event")) {
        return;
    }
    const category = ((_a = (element.getAttribute("category") || element.getAttribute("data-category"))) === null || _a === void 0 ? void 0 : _a.trim()) || null;
    const subCategory = ((_b = element.getAttribute("data-subcategory")) === null || _b === void 0 ? void 0 : _b.trim()) || null;
    const eventLabel = element.getAttribute("data-eventlabel");
    const eventValueType = element.getAttribute("data-eventvaluetype");
    const eventValue = element.getAttribute("data-eventvalue");
    let elText = "";
    for (const el of element.childNodes) {
        let text = el.textContent.trim();
        if (text !== "") {
            elText = text;
            break;
        }
    }
    if (eventLabel) {
        elText = eventLabel;
    }
    (0, ga_event_1.createEvent)({
        eventPage: page,
        eventCategory: category,
        eventSubCategory: subCategory,
        eventAction: (0, general_1.default)(`${event.type} ${elText}`.trim()),
        eventLabel: elText,
        eventValueType,
        eventValue,
    });
}
exports.onClickListener = onClickListener;
